import React, { FC, useState } from 'react';
import { Button, Modal } from 'antd';
import { IconBackground, SearchInput } from 'common/components';
import { EColor } from 'common/const';
import { getEmail } from 'common/helpers';
import { DEFAULT_VALUE_0 } from 'common/config';
import { IUser } from 'entities/User/User.models';
import { getUserName } from 'entities/User/User.helper';

interface IComponentProps {
  open: boolean;
  loading: boolean;
  userList: IUser[];
  onCancel: () => void;
  onSubmit: (record: IUser, onSuccess: () => void) => void;
}

export const PersonalLimitUsersModal: FC<IComponentProps> = (props) => {
  const { open, loading, userList, onCancel, onSubmit } = props;

  const [search, setSearch] = useState('');
  const [user, setUser] = useState<IUser | null>(null);

  const userListForView = userList.filter((user) => {
    return getUserName.fullName(user.lastName, user.firstName, user.patronymic).toLowerCase().includes(search.toLowerCase());
  });

  const onSearchChange = async (value?: string) => {
    setUser(null);
    setSearch(value || '');
  };

  const handleCancel = () => {
    if (loading) {
      return;
    }

    setSearch('');
    setUser(null);
    onCancel();
  };

  const handleSubmit = () => {
    if (!user) {
      return;
    }

    onSubmit(user, handleCancel);
  };

  return (
    <Modal
      rootClassName="redesign modal"
      width={400}
      centered
      open={open}
      onCancel={handleCancel}
      destroyOnClose
      closeIcon={false}
      footer={[
        <Button key="cancel" className="button-sm secondary" onClick={handleCancel}>
          Отмена
        </Button>,
        <Button key="save" className="button-sm primary" disabled={!user} onClick={handleSubmit}>
          Выбрать
        </Button>,
      ]}
    >
      <div className="mb-3 ff-medium fs-m">1. Выберите сотрудника</div>

      <div className="mb-6 ff-regular fs-xs color-dark-grey">
        Выберите сотрудника, которому будет назначен персональный лимит.
      </div>

      <div className="mb-6">
        <SearchInput auto placeholder="Поиск по сотрудникам" minLength={DEFAULT_VALUE_0} onSearch={onSearchChange} />
      </div>

      <div className="flex direction-column overflow-y-scroll scrollbar" style={{ height: 285 }}>
        {userListForView.length ? (
          userListForView.map((item) => {
            return (
              <Button
                key={item.id}
                className={`p-3 flex align-center text-start user-add-modal__list-item ${item.id === user?.id ? 'active' : ''}`}
                onClick={() => setUser(item)}
              >
                <IconBackground
                  content={
                    <span className="ff-bold fs-xs color-dark-grey">{getUserName.initials(item.lastName, item.firstName)}</span>
                  }
                  color={EColor.LightGrey}
                />

                <div>
                  <div className="mb-2 ff-medium fs-s color-black">
                    {getUserName.fullName(item.lastName, item.firstName, item.patronymic)}
                  </div>

                  <span className="ff-regular fs-xs color-dark-grey">{getEmail(item.email)}</span>
                </div>
              </Button>
            );
          })
        ) : (
          <div className="flex align-center justify-center flex-1 ff-regular fs-m color-dark-grey">Список пользователей пуст</div>
        )}
      </div>
    </Modal>
  );
};
